<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <path id="패스_3986" data-name="패스 3986" fill="none" d="M0,0H24V24H0Z" />
    <path
      id="빼기_15"
      data-name="빼기 15"
      fill="#21bf54"
      d="M18748,14246h-12a1.994,1.994,0,0,1-2-2v-10a1.932,1.932,0,0,1,.584-1.412,1.952,1.952,0,0,1,1.416-.588h12a2.007,2.007,0,0,1,2,2v10a2,2,0,0,1-2,2Z"
      transform="translate(-18730.004 -14224)"
    />
    <path
      id="빼기_16"
      data-name="빼기 16"
      fill="#363c43"
      d="M18742,14231h-2v-2a5,5,0,1,1,10,0v2h-2v-2a3,3,0,1,0-6,0v2Z"
      transform="translate(-18733 -14223)"
    />
    <path
      id="패스_4093"
      data-name="패스 4093"
      fill="#ffc304"
      d="M2,0A2,2,0,1,1,0,2,2,2,0,0,1,2,0Z"
      transform="translate(10 13)"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
